import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { GroupSettings, GroupSettingsProps } from './GroupSettings';

export function GroupSettingsCollapsible({
  groupIndex,
  settings,
  selectedTemplate,
  onChange
}: GroupSettingsProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mt-4 border rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 bg-gray-50 flex items-center justify-between hover:bg-gray-100 transition-colors"
      >
        <span className="font-medium text-gray-700">商品設定</span>
        {isOpen ? (
          <ChevronUp className="w-5 h-5 text-gray-400" />
        ) : (
          <ChevronDown className="w-5 h-5 text-gray-400" />
        )}
      </button>
      {isOpen && (
        <div className="p-4 bg-white">
          <GroupSettings
            groupIndex={groupIndex}
            settings={settings}
            selectedTemplate={selectedTemplate}
            onChange={onChange}
          />
        </div>
      )}
    </div>
  );
}